import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader } from "@/components/ui/Loader";
import { enviarPesquisaToken, fetchPesquisaToken, type PesquisaPublicaPayload } from "@/services/pesquisaNps";
import { FormularioNps, type RespostaMap } from "./FormularioNps";
import { PesquisaEstado, PesquisaNpsLayout } from "./PesquisaNpsLayout";

export function PesquisaNpsTokenPage() {
  const { token } = useParams<{ token: string }>();
  const [data, setData] = useState<PesquisaPublicaPayload | null>(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    fetchPesquisaToken(token)
      .then((res) => {
        if (!cancelled) setData(res);
      })
      .catch((e: unknown) => {
        const ax = e as { response?: { data?: PesquisaPublicaPayload } };
        if (!cancelled) {
          setData(
            ax.response?.data ?? {
              success: false,
              estado: "token_invalido",
              error: "Este link não é válido. Confira com o RH.",
            },
          );
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  if (loading) {
    return (
      <PesquisaNpsLayout>
        <div className="flex justify-center py-16">
          <Loader label="Carregando pesquisa..." />
        </div>
      </PesquisaNpsLayout>
    );
  }

  const estado = data?.estado;
  if (!data || estado === "token_invalido") {
    return <PesquisaEstado titulo="Link inválido" texto={data?.error ?? "Este link não é válido. Confira com o RH."} />;
  }
  if (estado === "indisponivel") {
    return <PesquisaEstado titulo="Indisponível" texto={data.error ?? "Esta pesquisa não está disponível no momento."} />;
  }
  if (estado === "encerrada") {
    return <PesquisaEstado titulo="Pesquisa encerrada" texto={data.error ?? "Esta pesquisa foi encerrada. Obrigado!"} />;
  }
  if (!data.pesquisa || !data.perguntas || !token) {
    return <PesquisaEstado titulo="Indisponível" texto="Esta pesquisa não está disponível no momento." />;
  }

  const tokenValue = token;

  async function enviar(answers: RespostaMap) {
    setSubmitting(true);
    try {
      const itens = data!.perguntas!.map((p) => ({
        perguntaId: p.id,
        valorNumero: answers[p.id]?.valorNumero ?? null,
        valorTexto: answers[p.id]?.valorTexto ?? null,
      }));
      const res = await enviarPesquisaToken(tokenValue, itens);
      if (res.estado === "ja_respondeu" || res.estado === "ok") return;
      throw Object.assign(new Error(res.error || "Falha ao enviar"), { response: { data: res } });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <PesquisaNpsLayout>
      <FormularioNps
        pesquisa={data.pesquisa}
        perguntas={data.perguntas}
        storageKey={`gg-nps-draft:${tokenValue}`}
        onSubmit={enviar}
        submitting={submitting}
      />
    </PesquisaNpsLayout>
  );
}
